 export enum CaseUpdatePresetFilterOptions {
    None = 1,
    Deleted = 2
}
